import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromStrategy from '@strategy/reducers';

import { BOND_LIST, MOBILE_VIEW_TRESHOLD } from '@app/app.constants';
import { CustomerInvestmentData } from '@shared/models/Strategy';
import { ThirdPartyServiceItem } from '@shared/models/ThirdPartService';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-setup-3a-portfolio',
  templateUrl: './setup-3a-portfolio.component.html',
  styleUrls: ['./setup-3a-portfolio.component.scss'],
  standalone: false
})
export class Setup3APortfolioComponent implements OnDestroy, OnInit {
  protected readonly onDestroy$ = new Subject<void>();
  @Output() updateTab = new EventEmitter<number>();
  @Input() step: number;

  customer: Customer;
  currentAccount: CustomerAccount;
  changeStrategyDisabled = false;
  flipperBookConsultation$: Observable<ThirdPartyServiceItem>;
  investmentData: CustomerInvestmentData;
  mobileView = false;
  showStrategyChanges = '';
  bondList = BOND_LIST;
  bookConsultation = false;
  showScroll = false;
  scroll = 0;
  strategyWasChanged = false;
  isSavingStrategyChangesEve2$: Observable<boolean>;
  strategyInfoLoaded$: Observable<boolean>;
  isEditMode: boolean;

  constructor(
    private store: Store,
    public router: Router,
    private trackingService: TrackingService
  ) {
    this.mobileView = window.innerWidth < MOBILE_VIEW_TRESHOLD;

    this.store
      .pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount), takeUntil(this.onDestroy$))
      .subscribe(({ customer, currentAccountDetail }) => {
        this.customer = customer;
        this.currentAccount = currentAccountDetail;
      });

    this.store.pipe(select(fromStrategy.selectCustomerInvestmentData), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.investmentData = response;
    });

    this.store.pipe(select(fromStrategy.selectChangeStrategyDisabled), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.changeStrategyDisabled = response;
    });

    this.store.pipe(select(fromStrategy.selectIsEditModeEve2), takeUntil(this.onDestroy$)).subscribe((isEditMode) => {
      this.isEditMode = isEditMode;
    });
    this.store.pipe(select(fromStrategy.selectStrategyWasChanged), takeUntil(this.onDestroy$)).subscribe(({ strategyWasChanged }) => {
      this.strategyWasChanged = strategyWasChanged;
    });
    this.isSavingStrategyChangesEve2$ = this.store.select(fromStrategy.selectIsSavingStrategyChangesEve2);
    this.strategyInfoLoaded$ = this.store.select(fromStrategy.selectStrategyInfoLoaded);

    this.flipperBookConsultation$ = this.store.select(
      fromAppRoot.selectThirdPartyServices('show_book_consultation')
    ) as Observable<ThirdPartyServiceItem>;
  }

  ngOnInit(): void {
    this.trackingService.trackView('/portfolio');
  }

  changeStrategy(): void {
    if (this.changeStrategyDisabled === false) {
      void this.router.navigate(['/strategy/adjust']);
    }
  }

  bookModal(value: boolean): void {
    this.bookConsultation = value;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  discardStrategy(): void {
    this.store.dispatch(StrategyActions.discardStrategyChangesEve2());
  }

  saveStrategy(): void {
    this.store.dispatch(StrategyActions.saveStrategyChangesEve2());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: Window }): void {
    if (event.target.innerWidth >= MOBILE_VIEW_TRESHOLD) {
      this.mobileView = false;
    } else {
      this.mobileView = true;
    }
  }

  scrollTop(): void {
    this.trackingService.trackActivity('[Button] Strategy portfolio: scroll back to top');
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:scroll') watchScroll() {
    if (this.showScroll === false) {
      if (window.scrollY < this.scroll) {
        this.showScroll = true;
      } else {
        this.scroll = window.scrollY;
      }
    }

    if (window.scrollY < 300) {
      this.showScroll = false;
    }
  }
}
